import React from 'react';

type WithEmptyViewProps = {
  EmptyView: () => React.ReactElement;
  isEmpty: boolean;
  View: () => React.ReactElement;
};

export const WithEmptyView = ({
  EmptyView,
  View,
  isEmpty,
}: WithEmptyViewProps): React.ReactElement => {
  if (isEmpty) return <EmptyView />;
  return <View />;
};

type WithEmptyStringProps = {
  empty: {
    message: string;
    className?: string;
    elementCustomizer?: (props: {
      EmptyView: () => React.ReactElement;
    }) => React.ReactElement;
  };
  View: () => React.ReactElement;
  isEmpty: boolean;
};

export const WithEmptyString = ({
  View,
  empty,
  isEmpty,
}: WithEmptyStringProps): React.ReactElement => {
  const Customizer =
    empty.elementCustomizer ??
    (({
      EmptyView,
    }: {
      EmptyView: () => React.ReactElement;
    }): React.ReactElement => <EmptyView />);
  const EmptyView_ = (): React.ReactElement => (
    <div
      className={`bg-gray-100 rounded-lg border-bluegray-300 border text-center p-4 mt-4 text-bluegray-500 text-sm ${empty.className}`}>
      {empty.message}
    </div>
  );
  const EmptyView = (): React.ReactElement => (
    <Customizer {...{ EmptyView: EmptyView_ }} />
  );
  return <WithEmptyView {...{ EmptyView, isEmpty, View }} />;
};
